/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_Misa_App_IdInputs */

const vi_einvoice_settings_misa_app_id = /** @type {(inputs: Einvoice_Settings_Misa_App_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã ứng dụng (AppID)`)
};

/**

* @param {Einvoice_Settings_Misa_App_IdInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_misa_app_id = /** @type {((inputs?: Einvoice_Settings_Misa_App_IdInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_Misa_App_IdInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_misa_app_id(inputs)
});